import { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import "./new-password-page-styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Loading from "../SpinnerAndError/Loading";

const InputNewPasswordPage = () => {
  const [email, setEmail] = useState();
  const [passwordFromInput, setPasswordFromInput] = useState();
  const [emailNotFoundInDatabase, setEmailNotFoundInDatabase] = useState(false);
  const [pleaseCheckYourEmail, setPleaseCheckYourEmail] = useState(false);
  const [emailNotFound, setEmailNotFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [
    userFoundButEmailNotVerifiedToGenerateNewPassword,
    setUserFoundButEmailNotVerifiedToGenerateNewPassword,
  ] = useState(false);
  const [
    userFoundButUserHasNotRequestedANewPassword,
    setUserFoundButUserHasNotRequestedANewPassword,
  ] = useState(false);

  let navigate = useNavigate();

  const onSubmitFunction = (event) => {
    event.preventDefault();
    setLoading(true);
    updateNewPasswordInDatabase();
  };

  const bodyData = {
    email: email,
    newpassword: passwordFromInput,
  };

  let updateNewPasswordInDatabase = async () => {
    const response = await fetch(
      process.env.REACT_APP_UPDATE_PASSWORD_IN_DATABASE,
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(bodyData),
      }
    );
    if (response.status === 201) {
      console.log("Response", response);
      const data = await response.json();
      console.log(data);
      setSuccess(true);
      setTimeout(() => {
        navigate("/");
      }, "3000");
      setLoading(false);
    } else if (response.status === 404) {
      console.log("Response", response);
      setEmailNotFoundInDatabase(true);
      setLoading(false);
    } else if (response.status === 401) {
      console.log("response", response);
      setUserFoundButEmailNotVerifiedToGenerateNewPassword(true);
      setLoading(false);
    } else if (response.status === 204) {
      setUserFoundButUserHasNotRequestedANewPassword(true);
      setLoading(false);
    } else {
      console.log("Email not found.");
      setEmailNotFound(true);
      setLoading(false);
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col xs={12} align="center">
          <div>
            <Helmet>
              <style>{"body { background-color: #264068; }"}</style>
            </Helmet>
            <div className="alert-messages-login-page">
              {success && (
                <Alert variant="success">
                  Password changed. 💪 We will now redirect you to the Login
                  page.
                </Alert>
              )}
              {emailNotFoundInDatabase && (
                <Alert variant="warning" style={{ paddingBottom: "0" }}>
                  <p>Did you enter the correct email. Please try again.</p>
                </Alert>
              )}
              {emailNotFound && (
                <Alert variant="warning">
                  Email not found in database. Are you sure you entered the
                  email correctly?
                </Alert>
              )}
              {userFoundButEmailNotVerifiedToGenerateNewPassword && (
                <Alert variant="warning">
                  <p>
                    User found and a new password request has been made, however
                    email has{" "}
                    <span style={{ textDecoration: "underline" }}>
                      not been verified in order to generate a new password.
                    </span>{" "}
                    <span style={{ fontWeight: "700" }}>
                      Please check your inbox again, thanks.
                    </span>
                  </p>
                </Alert>
              )}
              {userFoundButUserHasNotRequestedANewPassword && (
                <Alert variant="warning">
                  User found, but user has not requested a new password.
                </Alert>
              )}
            </div>
            <div className="login-page-h1 mt-2">
              <h1>New Password</h1>
            </div>
            <div
              className="login-page-outer-box"
              style={{ background: "white" }}
            >
              <div className="login-page-inner-box">
                <Form onSubmit={onSubmitFunction}>
                  <Form.Group controlId="formBasicEmail" className="mt=4">
                    <Form.Label className="login-page-form-labels">
                      Email
                    </Form.Label>
                    <Form.Control
                      className="login-page-input-fields"
                      required
                      type="email"
                      onChange={(event) => {
                        setEmail(event.target.value);
                      }}
                    />
                  </Form.Group>
                  <Form.Group controlId="formBasicPassword">
                    <Form.Label
                      className="login-page-form-labels"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      New Password
                    </Form.Label>
                    <Form.Control
                      className="login-page-input-fields"
                      required
                      type="password"
                      onChange={(event) => {
                        setPasswordFromInput(event.target.value);
                      }}
                    />
                  </Form.Group>

                  {loading === false ? (
                    <Button
                      variant="success"
                      type="submit"
                      size="lg"
                      className="login-page-button"
                    >
                      <span className="login-page-button-text">
                        Generate New Password
                      </span>
                    </Button>
                  ) : (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Loading></Loading>
                    </div>
                  )}
                </Form>
                <p className="login-page-dont-have-an-account-text">
                  Don't have an account?{" "}
                  <span id="login-page-dont-have-an-account-text-span">
                    {" "}
                    <a href="/signup">
                      <span style={{ padding: "2px" }}> </span> Sign Up
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default InputNewPasswordPage;
